import { FC, useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select, { GroupBase, OptionsOrGroups, SingleValue } from "react-select";

import AddProviderModal from "src/components/modals/addProvider";

import { DocFieldProps } from "../types";
import { getDocDetails } from "src/helpers/case";
import { AuthContext } from "src/context/authContext";



const DoctorField: FC<DocFieldProps> = ({ mode, shouldReset, fieldName, practice_id, control, isRequired, docListing, setValue, getDoctorListingByPracticeId, watch, trigger }): JSX.Element => {
  const [isModalVisible, updateModalVisibilty] = useState<boolean>(false)
  const [selectedDoctor, updateSelectedProvider] = useState<{ value: number; label: string; }>()

  const { userData } = useContext(AuthContext)
  // const is_anesthesiologist = Boolean(watch("doctor_attributes.is_anesthesiologist"));
  const iAm = watch("doctor_attributes.i_am");
  // setValue("doctor_attributes.is_anesthesiologist",is_anesthesiologist)
  const isPracUser = userData ? ["Practice", "Contact"].includes(userData.ref_type) : false
  const { inputLabel, inputPlaceholder, linkTitle } = getDocDetails(fieldName, isPracUser)


  useEffect(() => {
    if (shouldReset) {
      updateSelectedProvider(undefined)
      setValue(fieldName, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])

  useEffect(() => {
    if (!isModalVisible && selectedDoctor) {
      setValue(fieldName, selectedDoctor.value)
      trigger(fieldName)
      if (docListing && docListing.data)
        docListing.data.push({ id: selectedDoctor.value, first_last_name: selectedDoctor.label, fullname: selectedDoctor.label })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible])

  const updateSelectedProviderAndGetDocListing = (selectedDoc: { value: number; label: string; }, shouldUpdate: boolean) => {
    if (shouldUpdate)
      updateSelectedProvider(selectedDoc)

    getDoctorListingByPracticeId(practice_id)
  }

  const calculateProviderValue = (value?: number | null) => {
    if (!value || value === 0) return;

    if (docListing && docListing.data && value) {
      const data = docListing.data.find((doc) => doc.id === value)
      if (data)
        return { value: data.id, label: data.fullname }
    } else if (selectedDoctor) {
      return selectedDoctor
    }
  }

  return (
    <>
      <div className="col-md-12 col-lg-10">
        <Controller
          name={fieldName}
          control={control}
          defaultValue={0}
          render={({ field, fieldState: { error } }) => (
            <div className="row mb-2">
              <label htmlFor={fieldName} className="form-label col-lg-3 col-md-3 col-12 p-2">{inputLabel}{isRequired ? " *" : ""}</label>
              <div className="col-lg-9 col-md-9 col-12 treating-field">
                <Select
                  id={fieldName}
                  placeholder={inputPlaceholder}
                  required={isRequired}
                  {...field}
                  value={(field.value && calculateProviderValue(field.value as number)) as unknown as SingleValue<unknown>}
                  onChange={(val) => {
                    updateSelectedProvider(val as { value: number; label: string; })
                    field.onChange((val as { value: number; label: string; }).value)
                    trigger(fieldName)
                  }}
                  isSearchable={true}
                  noOptionsMessage={() =>
                    docListing && docListing.data && docListing.data.length === 0 ? 
                      "No doctor exists against selected practice..." :
                      undefined 
                  }
                  options={
                    (
                      docListing && docListing.data && docListing.data.length > 0 ?
                        docListing.data.map((doc) => ({ value: doc.id, label: doc.fullname }))
                      : []
                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                  }
                />
                {error && error.message ? (
                  <div dangerouslySetInnerHTML={{__html: error.message}} className="text-danger text-small mt-2"></div>
                ) : null}
              </div>
            </div>
          )}
        />
      </div>
      <div className="col-md-12 col-lg-2 text-end text-lg-start mb-2 mb-lg-0">
        <button onClick={() => updateModalVisibilty(true)} type="button" className="btn btn-primary">
          Add Provider
        </button>
      </div>

      {isModalVisible ? (
        <AddProviderModal 
          title={linkTitle} hideModal={() => updateModalVisibilty(false)}
          isModalVisible={isModalVisible} practice_id={practice_id || 0}
          updateModalDoctor={updateSelectedProviderAndGetDocListing}
          iAm={iAm}
        />
      ) : null}
    </>
  )
}

export default DoctorField
